// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(17, 24, 39, 0.35);
  overflow-y: scroll;
  z-index: 999;
}

.modal-content {
  background-color: var(--ui-surface);
  margin: 2% auto;
  padding: 24px;
  border: 1px solid var(--ui-border);
  width: 600px;
  height: auto;
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-md);

}

@media (max-width: 500px) {

.modal-content {
    width: 98%;

}
  }

.modal-header {
  position: relative;
  padding: 10px;
}

.modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -20px;
  width: 90%;
  height: 1px;
  background-color: var(--ui-border);
}

.modal .close {
  color: var(--ui-text);
  float: right;
  font-size: 20px;
  font-weight: bold;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-sm);
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 10px;
  opacity: .7;
  transition: all .2s ease-in;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px 7px 4px;
  transform: translate(50%);
}

.modal .close:hover,
.modal .close:focus {
  opacity: 1;
}

.modal-form {
  flex-basis: calc(100% - 10px) !important;
}

.modal-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Modal de confirmacao */
.confirmationmodal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 24, 39, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirmationmodal-container {
  background-color: var(--ui-surface);
  padding: 40px 20px;
  border-radius: var(--ui-radius-lg);
  width: 500px;
  text-align: center;
  border: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-md);
}

.confirmationmodal-content h2 {
  margin-bottom: 10px;
  font-size: 20px;
  color: var(--ui-text);
}

/* Lista de internos encontrados — linhas horizontais e compactas (foto pequena + info ao lado)
   em vez do card antigo com foto grande centralizada e texto embaixo, que ocupava muita altura
   por item. Com rolagem própria pra não deixar o modal gigante quando vêm muitos resultados. */
.internal-item-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 340px;
  overflow-y: auto;
  margin-top: 4px;
  padding-right: 4px;
  text-align: left;
}

.internal-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  cursor: pointer;
  background-color: var(--ui-surface);
  transition: background-color .15s ease, border-color .15s ease;
}

.internal-item:hover {
  background-color: var(--ui-input-bg, var(--ui-bg));
  border-color: var(--ui-primary);
}

.internal-item.is-disabled {
  cursor: not-allowed;
  opacity: .6;
}

.internal-item.is-disabled:hover {
  background-color: var(--ui-surface);
  border-color: var(--ui-border);
}

.internal-item-photo {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.internal-item-photo--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--ui-primary);
  color: var(--ui-primary-contrast, #fff);
  font-size: 15px;
  font-weight: 700;
}

.internal-item-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1 1;
}

.internal-item-info .internal-item-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ui-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.internal-item-status {
  align-self: flex-start;
  font-weight: 600;
}

.internal-item-blocked {
  font-size: 12px;
  color: var(--Vermelho);
}

.confirmationmodal-content p {
  margin-bottom: 20px;
  font-size: 20px;
}

.confirmationmodal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.confirmationmodal-actions .btn-confirm,
.confirmationmodal-actions .btn-cancel {
  border: none;
  border-radius: var(--ui-radius-md);
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
}

.confirmationmodal-actions .btn-confirm {
  background-color: var(--verde);
  color: #fff;
}

.confirmationmodal-actions .btn-cancel {
  background-color: transparent;
  color: var(--ui-primary);
  border: 1px solid var(--ui-primary);
}


/* Modal de confirmacao 2 */
.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(17, 24, 39, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-modal {
  background-color: var(--ui-surface);
  border-radius: var(--ui-radius-lg);
  padding: 20px;
  width: 400px;
  max-width: 100%;
  box-shadow: var(--ui-shadow-md);
  text-align: center;
}

.confirm-modal-header {
  margin-bottom: 15px;
}

.confirm-modal-icon {
  color: #ffcc00;
  font-size: 3rem;
}

.confirm-modal-body h2 {
  margin-bottom: 10px;
  font-size: 1.5rem;
  color: #333;
}

.confirm-modal-body p {
  margin-bottom: 20px;
  color: #666;
}

.confirm-modal-footer {
  display: flex;
  justify-content: space-around;
}

.confirm-button {
  background-color: var(--verde);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}



.cancel-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}

.cancel-button:hover {
  background-color: #e53935;

}

/* Quick Add Modal Styles */
.container-quick-modal {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

.container-quick-modal .form-group-lager {
  flex: 1 1;
  min-width: 0;
}

.quick-modal {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 35px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;

}

.quick-modal-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.quick-modal-input {
  margin-bottom: 10px;
  padding: 10px !important;
  width: 200px;
  font-size: 14px !important;
}

.btn-open-quick {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--ui-border, #c8d4e6);
  border-radius: 10px;
  background: #fff;
  padding: 0;
  margin: 0;
  line-height: 0;
  cursor: pointer;
  transform: none;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.btn-open-quick > img {
  width: 18px;
  height: 18px;
}

.btn-open-quick:hover {
  background: #f7faff;
  border-color: var(--texto-destaque);
}

.btn-open-quick:active {
  transform: translateY(1px);
}

.btn-open-quick:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(36, 90, 178, 0.2);
}

.quick-modal-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}

.quick-modal-button {
  margin: 5px;
  padding: 5px 10px;
  background-color: var(--verde);
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.quick-modal-button-cancel {
  margin: 5px;
  padding: 5px 10px;
  background-color: var(--Vermelho);
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.modal form {
  display: flex;
  flex-direction: column;
}

.modal form button {
  margin-top: 1rem;
  align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;;AAMjC;;AAJE;;AAVF;IAWI,UAAU;;AAGd;EAFE;;AAIF;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;+FAE+F;AAC/F;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,mCAAmC;EACnC,8DAA8D;AAChE;;AAEA;EACE,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,mCAAmC;AACrC;;;AAGA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".modal {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(17, 24, 39, 0.35);\n  overflow-y: scroll;\n  z-index: 999;\n}\n\n.modal-content {\n  background-color: var(--ui-surface);\n  margin: 2% auto;\n  padding: 24px;\n  border: 1px solid var(--ui-border);\n  width: 600px;\n  height: auto;\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-md);\n\n  @media (max-width: 500px) {\n    width: 98%;\n  }\n\n}\n\n.modal-header {\n  position: relative;\n  padding: 10px;\n}\n\n.modal-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -20px;\n  width: 90%;\n  height: 1px;\n  background-color: var(--ui-border);\n}\n\n.modal .close {\n  color: var(--ui-text);\n  float: right;\n  font-size: 20px;\n  font-weight: bold;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-sm);\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 10px;\n  opacity: .7;\n  transition: all .2s ease-in;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px 7px 4px;\n  transform: translate(50%);\n}\n\n.modal .close:hover,\n.modal .close:focus {\n  opacity: 1;\n}\n\n.modal-form {\n  flex-basis: calc(100% - 10px) !important;\n}\n\n.modal-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Modal de confirmacao */\n.confirmationmodal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(17, 24, 39, 0.35);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.confirmationmodal-container {\n  background-color: var(--ui-surface);\n  padding: 40px 20px;\n  border-radius: var(--ui-radius-lg);\n  width: 500px;\n  text-align: center;\n  border: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-md);\n}\n\n.confirmationmodal-content h2 {\n  margin-bottom: 10px;\n  font-size: 20px;\n  color: var(--ui-text);\n}\n\n/* Lista de internos encontrados — linhas horizontais e compactas (foto pequena + info ao lado)\n   em vez do card antigo com foto grande centralizada e texto embaixo, que ocupava muita altura\n   por item. Com rolagem própria pra não deixar o modal gigante quando vêm muitos resultados. */\n.internal-item-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 340px;\n  overflow-y: auto;\n  margin-top: 4px;\n  padding-right: 4px;\n  text-align: left;\n}\n\n.internal-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  cursor: pointer;\n  background-color: var(--ui-surface);\n  transition: background-color .15s ease, border-color .15s ease;\n}\n\n.internal-item:hover {\n  background-color: var(--ui-input-bg, var(--ui-bg));\n  border-color: var(--ui-primary);\n}\n\n.internal-item.is-disabled {\n  cursor: not-allowed;\n  opacity: .6;\n}\n\n.internal-item.is-disabled:hover {\n  background-color: var(--ui-surface);\n  border-color: var(--ui-border);\n}\n\n.internal-item-photo {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.internal-item-photo--placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--ui-primary);\n  color: var(--ui-primary-contrast, #fff);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.internal-item-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.internal-item-info .internal-item-name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ui-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.internal-item-status {\n  align-self: flex-start;\n  font-weight: 600;\n}\n\n.internal-item-blocked {\n  font-size: 12px;\n  color: var(--Vermelho);\n}\n\n.confirmationmodal-content p {\n  margin-bottom: 20px;\n  font-size: 20px;\n}\n\n.confirmationmodal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.confirmationmodal-actions .btn-confirm,\n.confirmationmodal-actions .btn-cancel {\n  border: none;\n  border-radius: var(--ui-radius-md);\n  padding: 8px 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.confirmationmodal-actions .btn-confirm {\n  background-color: var(--verde);\n  color: #fff;\n}\n\n.confirmationmodal-actions .btn-cancel {\n  background-color: transparent;\n  color: var(--ui-primary);\n  border: 1px solid var(--ui-primary);\n}\n\n\n/* Modal de confirmacao 2 */\n.confirm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(17, 24, 39, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.confirm-modal {\n  background-color: var(--ui-surface);\n  border-radius: var(--ui-radius-lg);\n  padding: 20px;\n  width: 400px;\n  max-width: 100%;\n  box-shadow: var(--ui-shadow-md);\n  text-align: center;\n}\n\n.confirm-modal-header {\n  margin-bottom: 15px;\n}\n\n.confirm-modal-icon {\n  color: #ffcc00;\n  font-size: 3rem;\n}\n\n.confirm-modal-body h2 {\n  margin-bottom: 10px;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.confirm-modal-body p {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.confirm-modal-footer {\n  display: flex;\n  justify-content: space-around;\n}\n\n.confirm-button {\n  background-color: var(--verde);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n\n\n.cancel-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.cancel-button:hover {\n  background-color: #e53935;\n\n}\n\n/* Quick Add Modal Styles */\n.container-quick-modal {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 8px;\n  width: 100%;\n}\n\n.container-quick-modal .form-group-lager {\n  flex: 1;\n  min-width: 0;\n}\n\n.quick-modal {\n  position: fixed;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 35px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 1001;\n\n}\n\n.quick-modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.quick-modal-input {\n  margin-bottom: 10px;\n  padding: 10px !important;\n  width: 200px;\n  font-size: 14px !important;\n}\n\n.btn-open-quick {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 1px solid var(--ui-border, #c8d4e6);\n  border-radius: 10px;\n  background: #fff;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  cursor: pointer;\n  transform: none;\n  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn-open-quick > img {\n  width: 18px;\n  height: 18px;\n}\n\n.btn-open-quick:hover {\n  background: #f7faff;\n  border-color: var(--texto-destaque);\n}\n\n.btn-open-quick:active {\n  transform: translateY(1px);\n}\n\n.btn-open-quick:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(36, 90, 178, 0.2);\n}\n\n.quick-modal-buttons {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.quick-modal-button {\n  margin: 5px;\n  padding: 5px 10px;\n  background-color: var(--verde);\n  border: none;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.quick-modal-button-cancel {\n  margin: 5px;\n  padding: 5px 10px;\n  background-color: var(--Vermelho);\n  border: none;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.modal form {\n  display: flex;\n  flex-direction: column;\n}\n\n.modal form button {\n  margin-top: 1rem;\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
